/**
 * Shared by the per-item page collections on airisk.mit.edu (incidents,
 * governance documents): the site origin and the slug rule. Browser-safe.
 */

export const SITE_ORIGIN = 'https://airisk.mit.edu';

const SLUG_MAX = 60;
const TRAILING_STOPWORDS = new Set(['a', 'an', 'and', 'as', 'at', 'by', 'for', 'from', 'in', 'of', 'on', 'or', 'the', 'to', 'with']);

/**
 * `<id>-<words of text>`, at most 60 characters, never ending on a stopword.
 * A sync uses it only when an item is CREATED: an existing item keeps its
 * slug for life.
 */
export function slugFrom(id: string, text: string): string {
  const words = text
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .split('-')
    .filter(Boolean);
  const kept: string[] = [];
  let len = id.length;
  for (const w of words) {
    if (len + 1 + w.length > SLUG_MAX) break;
    kept.push(w);
    len += 1 + w.length;
  }
  while (kept.length && TRAILING_STOPWORDS.has(kept[kept.length - 1])) kept.pop();
  return [id, ...kept].join('-');
}
